//@flow
import BaseCategoriesCollection from './baseCategoriesCollection';
import CategoryModel from './categoryModel';
import type { CategoryObject } from './categoryModel';
import _ from 'underscore';

export const OFFICE_BLACKLIST = [
  'm-buy-by-the-pound',
];

const allowedCategoriesUrlKeys = [
  'm-all-products',
  'm-new-this-month',
  'm-best-sellers',
  'm-mothers-day-faves',
  'm-labor-day-snacks',
  'm-sale',
  'm-summer-snacks',
  'm-brands-we-love',
  'm-memorial-weekend-snacks',
  'm-snack-boxes',
  'm-4th-of-july-snacks',
  'm-valentines-day-snacks',
  'm-variety-packs',
  'm-baked-treats',
  'm-chips-pretzels-popcorn',
  'm-popcorn',
  'm-dried-fruit-fruit-chews',
  'm-nuts-clusters',
  'm-snack-mixes',
  'm-jerky',
  'm-pantry-staples',
  'm-breakfast-bars',
  'm-meals',
  'm-squeeze-packs',
  'm-protein-shakes',
  'm-protein-bars',
  'm-beverages',
  'm-single-serve',
  'm-try-a-sample',
  'm-buy-by-the-pound',
  'm-wellness-snacks',
  'm-cbd-snacks',
  'm-supplements',
  'm-last-chance',
  'm-gifts',
  'm-back-in-stock',
  'm-hemp-extract-snacks',
  'm-adaptogenic-snacks',
  'm-moringa-snacks',
  'm-maca-snacks',
  'm-matcha-snacks',
  'm-turmeric-snacks',
  'm-ashwagandha-snacks',
  'chameleon-cold-brew-products',
  // 'm-sale',
  'elderberry-fruit-chews',
  'm-chameleon-dripkit',
];

const hideFromHeaderDropdown = [
  'm-gifts',
  'm-try-a-sample',
  'm-back-in-stock',
  'm-hemp-extract-snacks',
  'm-adaptogenic-snacks',
  'm-moringa-snacks',
  'm-maca-snacks',
  'm-matcha-snacks',
  'm-turmeric-snacks',
  'm-ashwagandha-snacks',
  'm-cbd-snacks',
  'chameleon-cold-brew-products',
  'm-protein-bars',
  'elderberry-fruit-chews',
  'm-chameleon-dripkit',
];

const hideFromSliderCategories = [
  'm-gifts',
  'm-back-in-stock',
  'm-hemp-extract-snacks',
  'm-adaptogenic-snacks',
  'm-moringa-snacks',
  'm-maca-snacks',
  'm-matcha-snacks',
  'm-turmeric-snacks',
  'm-ashwagandha-snacks',
  'm-supplements',
  'm-cbd-snacks',
  'chameleon-cold-brew-products',
  'm-protein-bars',
  'elderberry-fruit-chews',
  'm-chameleon-dripkit',
];

const hideFromRegularCategories = [
  'm-all-products',
  'm-gifts',
  'm-back-in-stock',
  'm-hemp-extract-snacks',
  'm-adaptogenic-snacks',
  'm-moringa-snacks',
  'm-maca-snacks',
  'm-matcha-snacks',
  'm-turmeric-snacks',
  'm-ashwagandha-snacks',
  'chameleon-cold-brew-products',
  'm-protein-bars',
  'elderberry-fruit-chews',
  'm-chameleon-dripkit',
];

const otherCategories = [
  'm-new-this-month',
  'm-best-sellers',
  'm-brands-we-love',
];

const highlightedCategories = [
];

const comingSoonCategories = [];

const membershipCategoryUrlKey = 'membership';

export default class CategoriesCollection extends BaseCategoriesCollection {
  newProductSkus:{ [string]:boolean } = {};
  comingSoonSkus:{ [string]:boolean } = {};

  constructor(modelsAttrs:?{[string]:CategoryObject}) {
    super(modelsAttrs);
    this.__sortCategories(this.models);

    const newCategory = this.findByUrlKey('m-new-this-month');
    _.each(newCategory && newCategory.getProductsSkus(), sku => this.newProductSkus[sku] = true);

    comingSoonCategories.forEach(urlKey => {
      const cat = this.findByUrlKey(urlKey);
      if (cat) {
        cat.getProductsSkus().forEach(sku => {
          this.comingSoonSkus[sku] = true;
        });
      }
    });
  }

  // NOTE: this is kind of a hack to blacklist certain
  // categories for when user is viewing catalog app
  // in office context.
  __removeItems(urlKeys:string[]) {
    this.models = this.models.filter(cat => !urlKeys.includes(cat.getUrlKey()));
  }

  __parse(data:?{[string]:CategoryObject}):CategoryObject[] {
    const categories = super.__parse(data);
    // for this collection, we only allow whitelisted categories
    return _.filter(categories, cat => allowedCategoriesUrlKeys.indexOf(cat.url_key) > -1);
  }


  __primaryCategoryUrlKey() {
    return 'membership';
  }

  productIsNew(sku:string):boolean {
    return this.newProductSkus[sku] || false;
  }

  productIsComingSoon(sku:string):boolean {
    return this.comingSoonSkus[sku] || false;
  }

  /**
   * Sorts categories by order in which their respective
   * url keys appear in referenceOrder
   */
  orderCategories(
    cats:CategoryModel[],
    referenceOrder:string[] = allowedCategoriesUrlKeys
  ):CategoryModel[] {
    // Create map of categories for easy
    // access by url key
    const asObject = cats.reduce((acc:Object, c:CategoryModel) => {
      acc[c.getUrlKey()] = c;
      return acc;
    }, {});

    // Iterate through referenceOrder. If url key
    // exists in map created above, push to array
    // If there are items in array to be sorted
    // not found in referenceOrder, add those at the
    // end
    const found = [];
    let items = [...cats];

    referenceOrder.forEach((key:string) => {
      const cat = asObject[key];
      if (cat) {
        found.push(cat);
        items = items.filter(i => i.getId() !== cat.getId());
      }
    });

    const ordered = [
      ...found,
      ...items,
    ];

    return ordered;
  }

  getDropdownCategories():CategoryModel[] {
    const filtered = _.reject(this.models, (category) => {
      return _.contains(hideFromHeaderDropdown, category.getUrlKey());
    });

    return this.orderCategories(filtered);
  }

  getSliderCategories() {
    const filtered = _.reject<CategoryModel>(this.models, (category) => {
      return _.contains<string>(hideFromSliderCategories, category.getUrlKey());
    });

    return this.orderCategories(filtered);
  }

  getRegularCategories():CategoryModel[] {
    const regularCategories = _.reject(this.models, (category) => {
      return _.contains(hideFromRegularCategories, category.getUrlKey());
    });

    return regularCategories;
  }

  getOtherCategories():CategoryModel[] {
    const filtered = _.filter(this.models, (category) => {
      return _.contains(otherCategories, category.getUrlKey());
    });
    return this.orderCategories(filtered, otherCategories);
  }

  __compareByArray(cat1:CategoryModel, cat2:CategoryModel, array:string[]) {
    const idx1 = array.indexOf(cat1.getUrlKey());
    const idx2 = array.indexOf(cat2.getUrlKey());

    if (idx1 < idx2) return -1;
    if (idx1 > idx2) return 1;
    return 0;
  }

  __compareDefault(cat1:CategoryModel, cat2:CategoryModel) {
    return this.__compareByArray(cat1, cat2, allowedCategoriesUrlKeys);
  }

  __getMembershipCategoryIds(data:?CategoryObject[]):string[] {
    const membershipCategory = _.find(data, (category) => {
      return category.url_key === membershipCategoryUrlKey;
    });

    if (!membershipCategory) return [];

    return membershipCategory.child_categories;
  }

  /*
   * Takes an array of category models and return a sorted array.
   */
  __sortCategories(categories:CategoryModel[]) {
    categories.sort(this.__compareDefault.bind(this));
  }
}

export const getIsCategoryHighlighted = (urlKey:string):boolean => {
  return highlightedCategories.includes(urlKey);
};
